import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from 'src/app/authentication/authentication.service';

@Component({
  selector: 'app-ip-verification-modal',
  templateUrl: 'ip-verification.modal.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule]
})
export class IpVerificationModalComponent {
  verificationCode = '';
  loading = false;
  errorMessage: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<IpVerificationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ipAddress?: string } | null,
    private authenticationService: AuthenticationService
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  submitForm(): void {
    if (!this.verificationCode.trim()) return;

    this.loading = true;
    this.errorMessage = null;

    this.authenticationService.verifyClientIpAddress(this.verificationCode.trim()).subscribe({
      next: () => {
        this.loading = false;
        this.dialogRef.close(true);
      },
      error: () => {
        this.loading = false;
        this.errorMessage = 'De verificatiecode is onjuist of verlopen. Probeer het opnieuw.';
      }
    });
  }
}
